module.exports = __webpack_public_path__ + "img/COMBO WAVES GREEN.81201f7.svg";